export const IMPORT_SIZE_BUCKETS = new Set(['empty', 'up_to_1_mib', '1_to_2_mib', '2_to_5_mib', '5_to_8_mib', '8_to_15_mib', 'over_15_mib']);

export function importSizeBucket(bytes: number): string {
  if (bytes === 0) return 'empty';
  if (bytes <= 1024 * 1024) return 'up_to_1_mib';
  if (bytes <= 2 * 1024 * 1024) return '1_to_2_mib';
  if (bytes <= 5 * 1024 * 1024) return '2_to_5_mib';
  if (bytes <= 8 * 1024 * 1024) return '5_to_8_mib';
  if (bytes <= 15 * 1024 * 1024) return '8_to_15_mib';
  return 'over_15_mib';
}
